// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.ultimate-security-passkeys {
  background-color: #ffffff;
  padding: 30px;
}
.ultimate-security-passkeys .dash-card {
  border-radius: 6px;
  border: 1px solid #D8D9DB;
  max-width: unset;
}
.ultimate-security-passkeys .card-body {
  padding: 1rem;
}
.ultimate-security-passkeys .card-body.p-4 {
  padding: 1.5rem !important;
}
.ultimate-security-passkeys .card-title {
  font-size: 1.125rem;
  font-weight: 500;
  margin-bottom: 1.5rem;
}
.ultimate-security-passkeys .stat-card {
  display: flex;
  align-items: center;
}
.ultimate-security-passkeys .failed-login-attempt {
  border: 10px solid #6BD2D1;
  border-radius: 100%;
}
.ultimate-security-passkeys .icon-circle {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin-right: 1rem;
}
.ultimate-security-passkeys .icon-circle .stat-content .stat-value {
  font-size: 1.75rem;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 0.25rem;
}
.ultimate-security-passkeys .icon-circle .stat-content .stat-label {
  font-size: 0.875rem;
  color: #6c757d;
  margin-bottom: 0;
}
.ultimate-security-passkeys .icon-circle .status-indicator {
  display: flex;
  align-items: center;
}
.ultimate-security-passkeys .icon-circle .status-indicator .status-text h4 {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 0.25rem;
}
.ultimate-security-passkeys .icon-circle .status-indicator .status-text p {
  margin-bottom: 0;
  color: #6c757d;
}
.ultimate-security-passkeys .icon-circle .list-unstyled {
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
}
.ultimate-security-passkeys .icon-circle .list-unstyled li {
  position: relative;
  padding-left: 1.25rem;
  margin-bottom: 0.75rem;
}
.ultimate-security-passkeys .icon-circle .list-unstyled li:last-child {
  margin-bottom: 0;
}
.ultimate-security-passkeys .icon-circle .list-unstyled li:before {
  content: "•";
  position: absolute;
  left: 0;
}
.ultimate-security-passkeys .icon-circle .header-with-link {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}
.ultimate-security-passkeys .icon-circle .header-with-link .card-title {
  margin-bottom: 0;
}
.ultimate-security-passkeys .icon-circle .header-with-link .view-link {
  color: #6f42c1;
  text-decoration: none;
  font-size: 0.875rem;
}
.ultimate-security-passkeys .icon-circle .header-with-link .view-link:hover {
  text-decoration: underline;
}
.ultimate-security-passkeys .icon-circle .card-stack {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/Passkeys/Passkeys.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAgBhB;EACC,yBAAA;EACG,aAAA;AAdJ;AAgBC;EACC,kBAdmB;EAenB,yBAAA;EACM,gBAAA;AAdR;AAiBC;EACC,aAlBY;AAGd;AAiBE;EACC,0BAAA;AAfH;AAoBC;EACC,mBAAA;EACA,gBAAA;EACA,qBA5Be;AAUjB;AAqBC;EACC,aAAA;EACA,mBAAA;AAnBF;AAsBI;EACI,0BAAA;EACA,mBAAA;AApBR;AAuBC;EACC,WAvCU;EAwCV,YAxCU;EAyCV,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAjDY;AA4Bd;AA0BG;EACC,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;AAxBJ;AA2BG;EACC,mBAAA;EACA,cAAA;EACA,gBAAA;AAzBJ;AA6BE;EACC,aAAA;EACA,mBAAA;AA3BH;AA8BI;EACC,iBAAA;EACA,gBAAA;EACA,sBAAA;AA5BL;AA+BI;EACC,gBAAA;EACA,cAAA;AA7BL;AAkCE;EACC,gBAAA;EACA,eAAA;EACA,gBAAA;AAhCH;AAkCG;EACC,kBAAA;EACA,qBAAA;EACA,sBAAA;AAhCJ;AAkCI;EACC,gBAAA;AAhCL;AAmCI;EACC,YAAA;EACA,kBAAA;EACA,OAAA;AAjCL;AAsCE;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBA/Gc;AA2EjB;AAsCG;EACC,gBAAA;AApCJ;AAuCG;EACC,cA/HM;EAgIN,qBAAA;EACA,mBAAA;AArCJ;AAuCI;EACC,0BAAA;AArCL;AA0CE;EACC,aAAA;EACA,sBAAA;EACA,WAAA;AAxCH","sourcesContent":["// WordPress Security Dashboard styles\n$primary: #6f42c1;\n$danger: #dc3545;\n$dark: #212529;\n$info: #20c997;\n\n// Card variables\n$card-border-radius: 6px;\n$card-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n$card-spacer: 1rem;\n$card-spacer-lg: 1.5rem;\n\n// Icon variables\n$icon-size: 50px;\n$icon-size-lg: 64px;\n\n.ultimate-security-passkeys {\n\tbackground-color: #ffffff;\n    padding: 30px;\n\n\t.dash-card {\n\t\tborder-radius: $card-border-radius;\n\t\tborder: 1px solid #D8D9DB;\n        max-width: unset;\n\t}\n\n\t.card-body {\n\t\tpadding: $card-spacer;\n\n\t\t&.p-4 {\n\t\t\tpadding: $card-spacer-lg !important;\n\t\t}\n        \n\t}\n\n\t.card-title {\n\t\tfont-size: 1.125rem;\n\t\tfont-weight: 500;\n\t\tmargin-bottom: $card-spacer-lg;\n\t}\n\n\t.stat-card {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t}\n\n    .failed-login-attempt{\n        border: 10px solid #6BD2D1;\n        border-radius: 100%;\n    }\n\n\t.icon-circle {\n\t\twidth: $icon-size;\n\t\theight: $icon-size;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tborder-radius: 50%;\n\t\tmargin-right: $card-spacer;\n\n\t\t\n\n\t\t.stat-content {\n\t\t\t.stat-value {\n\t\t\t\tfont-size: 1.75rem;\n\t\t\t\tfont-weight: 700;\n\t\t\t\tline-height: 1;\n\t\t\t\tmargin-bottom: 0.25rem;\n\t\t\t}\n\n\t\t\t.stat-label {\n\t\t\t\tfont-size: 0.875rem;\n\t\t\t\tcolor: #6c757d;\n\t\t\t\tmargin-bottom: 0;\n\t\t\t}\n\t\t}\n\n\t\t.status-indicator {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\n\t\t\t.status-text {\n\t\t\t\th4 {\n\t\t\t\t\tfont-size: 1.5rem;\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\tmargin-bottom: 0.25rem;\n\t\t\t\t}\n\n\t\t\t\tp {\n\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t\tcolor: #6c757d;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.list-unstyled {\n\t\t\tlist-style: none;\n\t\t\tpadding-left: 0;\n\t\t\tmargin-bottom: 0;\n\n\t\t\tli {\n\t\t\t\tposition: relative;\n\t\t\t\tpadding-left: 1.25rem;\n\t\t\t\tmargin-bottom: 0.75rem;\n\n\t\t\t\t&:last-child {\n\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t}\n\n\t\t\t\t&:before {\n\t\t\t\t\tcontent: \"•\";\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tleft: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.header-with-link {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t\talign-items: center;\n\t\t\tmargin-bottom: $card-spacer-lg;\n\n\t\t\t.card-title {\n\t\t\t\tmargin-bottom: 0;\n\t\t\t}\n\n\t\t\t.view-link {\n\t\t\t\tcolor: $primary;\n\t\t\t\ttext-decoration: none;\n\t\t\t\tfont-size: 0.875rem;\n\n\t\t\t\t&:hover {\n\t\t\t\t\ttext-decoration: underline;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.card-stack {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tgap: 1.5rem;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
